import React from 'react';
import classNames from 'classnames';
import { IPageTitleProps } from './PageTitle.types';
import styles from './PageTitle.module.css';

export const PageTitle: React.FC<IPageTitleProps> = ({ children, className }: IPageTitleProps) => {
  return <h1 className={classNames(styles.pageTitle, className)}>{children}</h1>;
};
